import { createBetaContributorsQuery } from "./beta"
import { createDrilldownContributorsQuery } from "./drilldown-helpers"
import { createDrilldownBaseGatherers, type DrilldownBaseGathererOptions } from "./drilldown-base"
import type { ContributorsQueryOptions } from "./contributors-query-types"

export function createDrilldownBetaContributorsQuery(options: ContributorsQueryOptions) {
  // Beta contributor values use metric field names (predicted, historical), not factor ids.
  return createDrilldownContributorsQuery(createBetaContributorsQuery, [], options)
}

export function createBetaDrilldownGatherers({
  endDate,
  startDate,
  selectedFactor,
  classifications,
  instrumentSuffix = "",
  ...coreOptions
}: DrilldownBaseGathererOptions & { selectedFactor?: string }) {
  const baseGatherers = createDrilldownBaseGatherers({
    ...coreOptions,
    endDate,
    startDate,
    classifications,
    instrumentSuffix,
  })
  const betaGatherer = createDrilldownBetaContributorsQuery({
    ...coreOptions,
    prefix: `beta${instrumentSuffix}`,
    to: endDate,
    selectedFactor,
  })
  return [...baseGatherers, betaGatherer]
}
